import { SET_IS_SHOW_LOGIN_MODAL } from "../../constants/reduxKeys";

export function setIsShowLoginModal(bool) {
  return {
    type: SET_IS_SHOW_LOGIN_MODAL,
    payload: bool,
  };
};